export default __webpack_public_path__ + "static/media/jakarta.64756e36.png";